import { render, staticRenderFns } from "./IconCloseV2.vue?vue&type=template&id=447770fa&"
import script from "./IconCloseV2.vue?vue&type=script&lang=js&"
export * from "./IconCloseV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports